import React from "react";
import { Button, Modal, ModalBody, ModalFooter } from "reactstrap";
export const ModalDialog = ({ open, message, handleCancel, handleGotIt }) => {
  return (
    <Modal isOpen={open} centered>
      <ModalBody>{message}</ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleCancel}>
          Cancel
        </Button>
        <Button color="primary" onClick={handleGotIt}>
          Confirm
        </Button>
      </ModalFooter>
    </Modal>
  );
};
